const requireContext = require.context('.', true, /\.vue$/);
let components = {};
requireContext
  .keys()
  .filter((path) => path !== './index.vue')
  .forEach((path) => {
    const file = requireContext(path);
    components[file.default.name] = file.default;
  });

export default components;
